import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component, Inject, OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import { AppState } from "./app.service";
import { L10N_LOCALE, L10nTranslationService, L10nLocale } from "angular-l10n";
import { AuthService } from "./services/auth.service";
import { BusyIconService } from "./services/busy.service";
import { CgBusyDefaults } from "angular-busy2";
import { Subject, Subscription } from "rxjs";
import "bootstrap";
import "hammerjs";
import { UserService } from "./services/user.service";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from "@angular/router";
import { EUserType } from "./models/userInfo.model";
import { takeUntil } from "rxjs/operators";
import { environment } from "../environments/environment";

declare let $: any;

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: "app",
  templateUrl: "app.template.html",
  styleUrls: ["app.style.less"],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
  @ViewChild("busyTemplate") busyTemplate: TemplateRef<any>;

  public EUserType = EUserType;
  public loadingIcon = "assets/img/OCCON_icon.png";

  public userIsLoggedIn: boolean = false;

  public busySubscription: Subscription;
  private subscription: Subscription;

  private _onDestroy$: Subject<void> = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef, private busyDefaults: CgBusyDefaults, public busyIconService: BusyIconService,
              private userService: UserService, public appState: AppState,
              @Inject(L10N_LOCALE) public locale: L10nLocale, public translation: L10nTranslationService, private authService: AuthService, public router: Router) {
  }

  public ngOnInit() {
    const language = localStorage.getItem("currentLanguage");
    if (language) {
      this.changeLanguage(language);
    }
  }

  ngAfterViewInit() {
    // -
  }

  ngAfterContentInit() {
    this.subscription = this.busyIconService.getBusySubscription()
      .pipe(takeUntil(this._onDestroy$))
      .subscribe((subscription: Subscription) => {
        this.busySubscription = subscription;
        this.cdr.detectChanges();
      });
    this.authService.$loggedIn
      .pipe(takeUntil(this._onDestroy$))
      .subscribe((isUserLoggedIn) => {
        this.userIsLoggedIn = isUserLoggedIn;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  private changeLanguage(language: string): void {
    this.translation.setLocale({language});
    localStorage.setItem("currentLanguage", language.toLowerCase());
  }
}
